// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import CustomPageLayout from "examples/LayoutContainers/CustomPageLayout";
import { Grid } from "@mui/material";

import AddTenantForm from "components/Tenants/AddTenantForm";

function AddTenants() {
  return (
    <CustomPageLayout>
      <MDBox pt={3} pb={3}>
        <Card>
          <MDBox p={3} lineHeight={1}>
            <Grid container justifyContent="space-between" spacing={3}>
              <Grid item>
                <MDTypography variant="h5" fontWeight="medium">
                  Register Tenant
                </MDTypography>
                <MDTypography variant="button" color="text">
                  Register new tenant in the system from here.
                </MDTypography>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox  px={3} pb={3} lineHeight={1}>
            <AddTenantForm />
          </MDBox>
        </Card>
      </MDBox>
    </CustomPageLayout>
  );
}

export default AddTenants;
